var map = {
	"./croc1.jpg": 4942,
	"./croc10.jpg": 3970,
	"./croc11.jpg": 4724,
	"./croc12.jpg": 8285,
	"./croc2.png": 1361,
	"./croc3.jpg": 7593,
	"./croc4.jpg": 9213,
	"./croc5.jpg": 6039,
	"./croc6.jpg": 6078,
	"./croc7.jpg": 4668,
	"./croc8.jpg": 8337,
	"./croc9.jpg": 3768,
	"./dog1.jpg": 8321,
	"./dog10.jpg": 9254,
	"./dog11.jpg": 6173,
	"./dog12.jpg": 3297,
	"./dog2.jpg": 966,
	"./dog3.jpeg": 7196,
	"./dog4.jpg": 4190,
	"./dog5.png": 5221,
	"./dog6.jpg": 3545,
	"./dog7.jpg": 484,
	"./dog8.jpg": 5643,
	"./dog9.png": 2169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;